import React from 'react';
import { Navigate } from 'react-router-dom';
import SettingsPage from '../../components/settings-page/SettingsPage';
import { ScreenWorkspaceSettings } from '../../classes/consts/Screen';
import { useAuth } from '../../contexts/auth';

export default function WorkspaceSettings() {
    const { sessionDetail } = useAuth();

    // Workspaces only exist in enterprise mode: their screens live under the global settings otherwise.
    if (sessionDetail && !sessionDetail.EnterpriseMode) {
        return <Navigate to="/global-settings" replace />;
    }

    return (
        <SettingsPage
            screenConst={ScreenWorkspaceSettings}
            titleMessageKey="WorkspaceSettingsScreen_Title"
        />
    );
}
